import { useSelector } from 'react-redux';

export interface PDFConfig {
  hospitalName: string;
  logoBlob: string;
  locale: string;
  address: string;
  city: string;
  email: string;
  phone: string;
}

export const usePDFConfig = () => {
  const currentInvestigation = useSelector((state: any) => state.investigations.currentInvestigation);
  
  if (!currentInvestigation || !currentInvestigation.billingInfo) {
    return {
      config: null,
      loading: false,
      error: 'No billing information available'
    };
  }
  
  const billingInfo = currentInvestigation.billingInfo;
  const config: PDFConfig = {
    hospitalName: currentInvestigation.name || billingInfo.hospitalName,
    logoBlob: billingInfo.logoBlob,
    locale: billingInfo.locale || 'en',
    address: billingInfo.address,
    city: billingInfo.city,
    email: billingInfo.email,
    phone: billingInfo.phone
  };
  
  return {
    config,
    loading: false,
    error: null
  };
}; 